import React from 'react'
import { NavLink } from 'react-router-dom'
import { LogoIcons } from '../Icons/Icons'

const Footer = () => {
    return (
        <section className='bg__blue pb-4'>
            <div className="container">
                <div className="row mb-4 mb-sm-5 align-items-start">
                    {/* Logo + Description */}
                    <div className="col-lg-4 mb-4 mb-lg-0">
                        <div className="d-flex align-items-center mb-3">
                            <span className="color__white font__size--24 text__20-1024 semi-bold ml-2">
                                AYA<span className="normal">BELAL</span>
                            </span>
                        </div>
                        <p className="normal font__size--16 text__16-1024 color__gray-3">
                            Get fit, stay healthy, and live life on our terms without fitness being an obstacle.
                        </p>
                    </div>

                    {/* Footer Menu */}
                    <div className="col-lg-8 mb-4 mb-lg-0">
                        <div className="wrapper__menu-footer d-flex flex-wrap align-items-center justify-content-start gap-4 ps-0">
                            <NavLink to="/" className="medium font__size--16 text__16-1024 color__white opacity__5 hover">
                                Home
                            </NavLink>
                            <NavLink to="/faqs" className="medium font__size--16 text__16-1024 color__white opacity__5 hover">
                                FAQs
                            </NavLink>
                            <NavLink to="/membership" className="medium font__size--16 text__16-1024 color__white opacity__5 hover">
                                Membership
                            </NavLink>
                            <NavLink to="/contact" className="medium font__size--16 text__16-1024 color__white opacity__5 hover">
                                Contact
                            </NavLink>
                            <NavLink to="/about" className="medium font__size--16 text__16-1024 color__white opacity__5 hover">
                                About Us
                            </NavLink>
                        </div>
                    </div>
                </div>

                <img src="./../images/Line@2x.png" className="w-100 mb-4" alt="" />

                {/* Bottom Section */}
                <div className="d-md-flex align-items-center justify-content-between position-relative">
                    <p className="mb-0 normal font__size--16 text__16-1024 color__gray-3">
                        © 2025 ayabelal nutritionist.
                    </p>

                    <div className="wrapper__sosmed center d-flex align-items-center justify-content-md-center my-3 my-md-0">
                        <a href="https://www.facebook.com/share/14M9ZA683JR/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                            <img src="./../images/svg.png" alt="Facebook" />
                        </a>
                        <a href="https://youtube.com/@ayabelal.nutritionist?si=Ma2OfukNHpM3o4zU" target="_blank" rel="noopener noreferrer">
                            <img src="./../images/svg (3).png" alt="YouTube" />
                        </a>
                        <a href="https://www.instagram.com/ayabelal.nutritionist?igsh=NzAxNWRraXpmc3Fm&utm_source=qr" target="_blank" rel="noopener noreferrer">
                            <img src="./../images/svg (4).png" alt="Instagram" />
                        </a>
                        <a href="https://www.tiktok.com/@ayabelal.nutritionist?_r=1&_t=ZS-919sHve7Zfo" target="_blank" rel="noopener noreferrer">
                            <img src="./../images/svg (5).png" alt="Instagram" />
                        </a>
                    </div>

                    <div className="d-flex align-items-center">
                        <NavLink to="/terms" className="medium font__size--16 text__16-1024 color__white opacity__5 hover">
                            Terms & Conditions
                        </NavLink>
                        <a
                            href="https://habibauiux.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="medium font__size--16 text__16-1024 color__white opacity__5 hover ml-3"
                        >
                            Developed by: Habiba
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer
